/** BookingsKpiCellContent — the label/value/sub markup shared by
 *  {@link BookingsKpiCell}'s button and non-interactive-div branches (BON-490
 *  a11y review). Extracted so neither branch duplicates the JSX. */
import { TONE_CLASS, type FillSegment } from '../../primitives';

export function BookingsKpiCellContent({
  label,
  value,
  sub,
  tone,
  filled,
}: {
  label: string;
  value: number;
  sub: string;
  tone?: FillSegment['tone'];
  filled?: boolean;
}) {
  return (
    <>
      <span style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
        {tone && (
          <i
            aria-hidden="true"
            className={`nb-seg-swatch ${TONE_CLASS[tone]}`}
            style={{ width: 8, height: 8, borderRadius: 2, display: 'inline-block' }}
          />
        )}
        <span
          className="nb-eyebrow"
          style={{ fontSize: 9, color: filled ? 'rgba(255,255,255,.75)' : undefined }}
        >
          {label}
        </span>
      </span>
      <span
        className="nb-tabular"
        style={{
          display: 'block',
          fontSize: 25,
          fontWeight: 700,
          lineHeight: 1.15,
          letterSpacing: '-.02em',
          color: filled ? '#fff' : 'var(--nb-ink)',
          marginTop: 3,
        }}
      >
        {value}
      </span>
      <span
        style={{
          display: 'block',
          fontSize: 10.5,
          marginTop: 1,
          color: filled ? 'rgba(255,255,255,.8)' : 'var(--nb-subtle)',
        }}
      >
        {sub}
      </span>
    </>
  );
}
